module.exports = __webpack_public_path__ + "static/media/stanley.1753fca1.jpg";